<!-- 客户详情 -->
<template>
    <div>
        <veui-drawer
            overlay-class="customer-detail"
            placement="right"
            title="客户信息详情"
            :footless="true"
            :outside-closable="true"
            :open="open"
            :modal="true"
            @cancel="close"
        >
            <!-- 客户信息 -->
            <div class="info">
                <div class="column">
                    <div class="item">
                        <div class="title">客户姓名</div>
                        <div class="content">{{ data.name || '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="title">线索来源</div>
                        <div class="content">{{ +data.enter_type === 2 ? '自主入驻' : '代理商引入'}}</div>
                    </div>
                    <div class="item">
                        <div class="title">执业资格证号</div>
                        <div class="content">{{ data.encodeLicense || '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="title">手机号</div>
                        <div class="content">{{ data.encodePhone || '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="title">城市</div>
                        <div class="content">{{ data.city_name | cityNameFilter }}</div>
                    </div>
                    <div class="item">
                        <div class="title">客保次数</div>
                        <div class="content">{{ count || 0 }}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <div class="title">是否领取体验会员</div>
                        <div class="content">{{ data.free_vip ? +data.free_vip === 2 ? '是' : '否' : '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="title">入驻时间</div>
                        <div class="content">{{ data.lawyer_enter_time | dateFilter }}</div>
                    </div>
                    <div class="item">
                        <div class="title">会员码生效时间</div>
                        <div class="content">{{ data.vip_start_time | dateFilter }}</div>
                    </div>
                    <div class="item">
                        <div class="title">会员码失效时间</div>
                        <div class="content">{{ data.vip_end_time | dateFilter }}</div>
                    </div>
                    <div class="item">
                        <div class="title">转化意愿</div>
                        <div class="content">{{ +data.intention_count > 0 ? '强' : '正常' }}</div>
                    </div>
                </div>
            </div>
            <!-- 客保记录 -->
            <div class="record">
                <div class="title">客保记录</div>
                <div class="record-content">
                    <div v-if="!recordList || !recordList.length" class="no-data">暂无客保记录</div>
                    <div v-else class="item" v-for="item, index in recordList" :key="index">
                        <div class="icon"></div>
                        <div class="start-date">{{ item.ci_start_time | dateFilter }}</div>
                        <div class="status">{{ item.op_mode || '-' }}</div>
                    </div>
                </div>
                <!-- 分页 -->
                <veui-pagination
                    v-if="recordList && recordList.length"
                    :page="pn"
                    :page-size="rn"
                    :total="count"
                    class="pagination"
                    @redirect="pageChange"
                />
            </div>
        </veui-drawer>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 客户详情
 * @author dingzhenyue
 */
import {Drawer, Pagination} from 'veui';
import {userTypeFilter} from '../../potential-customer-list/util/filter';
import {dateFilter, cityNameFilter} from '@/utils/filter';
import {OP_MODE} from '../../../common/curstomer-detail/config';

export default {
    name: 'customer-detail',
    props: {
        open: {
            'type': Boolean,
            'default': false
        },
        // 详情数据
        data: {
            'type': Object,
            'default': () => {}
        }
    },
    components: {
        'veui-drawer': Drawer,
        'veui-pagination': Pagination
    },
    data() {
        return {
            pn: 1,
            rn: 5,
            // 客保总数
            count: 0,
            // 咨询记录
            recordList: []
        };
    },
    filters: {
        userTypeFilter,
        dateFilter,
        cityNameFilter
    },
    mounted() {
        this.getDetail();
    },
    methods: {

        /**
         * 关闭当前抽屉
         */

        close() {
            this.$emit('closeDrawer');
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.pn = pn;
            this.getDetail();
        },

        /**
         * 获取详情
         */

        getDetail() {
            this.$http.post('/bp/crm/getcrmrecord', {
                license: this.data?.license || '',
                pn: this.pn,
                rn: this.rn
            }).then(res => {
                const data = this.$normalizeResponseData(res);
                if (!data) {
                    return;
                }
                this.recordList = data?.list || [];
                this.recordList.forEach(item => item.op_mode = OP_MODE[item.op]);
                this.count = data?.count || 0;
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        }
    }
};
</script>

<style lang='less' scoped>
.customer-detail {
    /deep/.veui-dialog-content-head {
        align-items: center;
        padding-bottom: 28px;

        .veui-dialog-content-head-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 16px;
        }
    }

    /deep/.veui-dialog-content {
        width: 990px;
    }

    .veui-dialog-content-body {
        margin-top: 24px;
    }

    .info {
        display: flex;

        .column {
            display: flex;
            flex-direction: column;

            &:last-child {
                margin-left: 220px;
            }
        }

        .item {
            display: flex;
            font-size: 14px;
            color: #333333;
            line-height: 14px;
            padding-bottom: 30px;

            .title {
                width: 112px;
            }

            .content {
                margin-left: 22px;
            }
        }
    }

    .record {
        margin-top: 10px;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 16px;
            margin-bottom: 30px;
        }

        .record-content {
            border: 1px solid rgba(233, 236, 243, 1);
            border-radius: 8px;
            padding: 15px 13px;

            .no-data {
                text-align: center;
            }

            .item {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                line-height: 12px;
                font-weight: 400;
                display: flex;
                align-items: center;
                position: relative;
                color: #999999;

                &:not(:first-child) {
                    margin-top: 42px;
                }

                .icon {
                    height: 21px;
                    width: 21px;
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/customer-sea/record-icon.png) no-repeat center / 100% 100%;
                }

                .vertical-line {
                    width: 1px;
                    height: 36px;
                    top: 24px;
                    background: #E5E8FA;
                    position: absolute;
                    left: 10px;
                }

                .start-date {
                    margin-left: 25px;
                }

                .line {
                    padding: 0 6px;
                }

                .end-date {
                }

                .status {
                    margin-left: 90px;
                }
            }
        }

        .pagination {
            float: right;
            padding-top: 30px;
        }
    }
}

.foot {
    position: absolute;
    bottom: 24px;
    right: 30px;
}

/deep/.veui-button.veui-dialog-content-head-close {
    color: #000;
}
</style>


